import React, { useState, useRef, useEffect } from "react";
import { extractVariables } from "../../commonFunctions/fileFolderConfig";
import { useTableContext } from "../../context/TableContext";
import MaterialIcon from "../../components/BuilderComponents/MaterialIcon";
import Input from "../../components/FormComponents/Input";
import BuilderRightSideBar from "../../Layouts/BuilderRightSideBar";
import BuilderModal from "../../Layouts/Modal/BuilderModal";
import TableTreeModal from "../../components/BuilderComponents/TableTreeModal";

const SuccessError = ({ data, onChange, tableID }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { getSingleTableData } = useTableContext();
  const tableRef = useRef({});
  const [isRightbarOpen, setIsRightbarOpen] = useState(false);

  const onChangeHandler = (e) => {
    const newData = { ...data, [e.target.name]: e.target.value };
    const arr = extractVariables(newData.success_message + " " + newData.error_message);
    let obj = {};
    data.variable_mapping = data.variable_mapping || {};
    arr.forEach((vrbl) => {
      obj[vrbl] = data.variable_mapping[vrbl] || "";
    });
    newData.variable_mapping = obj;
    onChange(newData);
  };

  const addField = (obj) => {
    onChange({ ...data, variable_mapping: { ...data.variable_mapping, [isModalOpen]: obj } });
    setIsModalOpen(false);
  };

  useEffect(() => {
    const { tableObject } = getSingleTableData(tableID);
    tableRef.current = tableObject;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleOpenRightSidebar = () => {
    setIsRightbarOpen(true);
  };

  return (
    <div className="message_container">
      <div style={{ position: "relative" }}>
        <div
          className="activity_select_top_block builder_form"
          style={{ width: "100%", margin: "20px auto 20px auto", minHeight: "75px" }}
        >
          <div className="form_edit_del_buttons">
            <button
              className="builder_action_btn edit"
              title="Edit"
              style={{ width: "32px", height: "32px", fontsize: "20px" }}
              onClick={handleOpenRightSidebar}
            >
              <MaterialIcon name="edit" style={{ fontSize: "20px" }} />
            </button>
          </div>
          <div className="overlay_cover"></div>
          <div className="stateMachine_form_container" style={{ margin: "4px auto 4px auto", gap: "8px" }}>
            {data.success_message && (
              <div style={{ color: "green" }} onClick={handleOpenRightSidebar}>
                {data.success_message}
              </div>
            )}
            {data.error_message ? (
              <div style={{ color: "red" }} onClick={handleOpenRightSidebar}>
                {data.error_message}
              </div>
            ) : (
              <div style={{ color: "red" }} onClick={handleOpenRightSidebar}>
                Default Message
              </div>
            )}
          </div>
        </div>
      </div>
      <BuilderRightSideBar isOpen={isRightbarOpen} heading="Add Message" onClose={() => setIsRightbarOpen(false)}>
        <div className="edit_activity_job small">
          <div className="builder_form">
            <Input
              type="text"
              name="success_message"
              label="Success Message"
              value={data.success_message}
              onChange={onChangeHandler}
            />
            <Input
              type="text"
              name="error_message"
              label="Error Message"
              value={data.error_message}
              onChange={onChangeHandler}
            />
            <table>
              <thead>
                <tr>
                  <th>Key</th>
                  <th>Value</th>
                </tr>
              </thead>
              <tbody>
                {Object.keys(data.variable_mapping || []).map((variable) => (
                  <tr key={variable}>
                    <td>{variable}</td>
                    <td onClick={() => setIsModalOpen(variable)}>
                      {data.variable_mapping[variable].id
                        ? tableRef.current[data.variable_mapping[variable].id]?.display
                        : "select field"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <BuilderModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} modalName="Select Field">
            <TableTreeModal tableId={tableID} callbackFunction={addField} />
          </BuilderModal>
        </div>
      </BuilderRightSideBar>
    </div>
  );
};

export default SuccessError;
